export default __webpack_public_path__ + "static/media/1439.ce42d84e.png";